const PERM_BITS: { perm: string, bit: bigint }[] = [
    {perm: 'login', bit: 1n << 0n},
    {perm: 'save-report', bit: 1n << 1n},
    {perm: 'cancel-order', bit: 1n << 2n},
    {perm: 'search-products', bit: 1n << 3n},
    {perm: 'clockin', bit: 1n << 4n},
    {perm: 'basic-auth', bit: 1n << 5n},
    {perm: 'close-count', bit: 1n << 6n},
    {perm: 'search-snapshots', bit: 1n << 7n},
    {perm: 'approve-report', bit: 1n << 8n},
    {perm: 'search-items', bit: 1n << 9n},
    {perm: 'search-locations', bit: 1n << 10n},
    {perm: 'create-count', bit: 1n << 11n},
    {perm: 'list-bins', bit: 1n << 12n},
    {perm: 'search-truck-counts', bit: 1n << 13n},
    {perm: 'assign-iteration', bit: 1n << 14n},
    {perm: 'search-counts', bit: 1n << 15n},
    {perm: 'adjust-items', bit: 1n << 16n},
    {perm: 'submit-report', bit: 1n << 17n},
    {perm: 'fulfill-order', bit: 1n << 18n},
    {perm: 'deserialize-item', bit: 1n << 19n},
    {perm: 'clockout', bit: 1n << 20n},
    {perm: 'receive-replenishment', bit: 1n << 21n},
    {perm: 'return-request', bit: 1n << 22n},
    {perm: 'create-replenishment', bit: 1n << 23n},
    {perm: 'search-truck-transfers', bit: 1n << 24n},
    {perm: 'reroute-transfers', bit: 1n << 25n},
    {perm: 'transfer-inventory', bit: 1n << 26n},
    {perm: 'search-transfers', bit: 1n << 27n},
    {perm: 'webevents-connect', bit: 1n << 28n},
    {perm: 'webevents-log', bit: 1n << 29n},
    {perm: 'get-count', bit: 1n << 30n},
    {perm: 'get-truck-count', bit: 1n << 31n},
    {perm: 'open-receipt', bit: 1n << 32n},
    {perm: 'save-receipt', bit: 1n << 33n},
    {perm: 'submit-receipt', bit: 1n << 34n},
    {perm: 'search-users', bit: 1n << 35n},
    {perm: 'get-transfer-request', bit: 1n << 36n},
    {perm: 'get-truck-transfer-request', bit: 1n << 37n},
    {perm: 'search-transfer-requests', bit: 1n << 38n},
    {perm: 'search-truck-transfer-requests', bit: 1n << 39n},
    {perm: 'create-transfer-request', bit: 1n << 40n},
    {perm: 'approve-transfer-request', bit: 1n << 41n},
    {perm: 'select-transfer-request-serials', bit: 1n << 42n},
    {perm: 'reject-transfer-request', bit: 1n << 43n}
]

export type RoutePerms = {
    path: string
    perms: (string | string[])[] // evaluated as: string && array[a || b] && string
}

const ROUTE_PERMS: RoutePerms[] = [
    {
        path: '/inventory/counts/conduct',
        perms: ['assign-iteration', ['search-counts', 'search-truck-counts'], 'search-products']
    },
    {
        path: '/inventory/counts/manage',
        perms: ['create-count', 'search-counts', 'close-count', 'search-products', 'search-locations']
    },
    {
        path: '/inventory/counts/review',
        perms: ['approve-report', 'search-counts', 'close-count']
    },
    {
        path: '/inventory/counts/bin',
        perms: ['save-report', 'submit-report', 'list-bins']
    },
    {
        path: '/inventory/counts/sample',
        perms: ['save-report', 'submit-report']
    },
    {
        path: '/inventory/receive',
        perms: [['search-truck-transfers', 'search-transfers']]
    }, {
        path: '/inventory/receiving',
        perms: ['open-receipt', 'save-receipt', 'submit-receipt']
    },
    {
        path: '/inventory/transfer-requests',
        perms: [['search-truck-transfer-requests', 'search-transfer-requests']]
    },
    {
        path: '/inventory/transfer-requests/create',
        perms: ['create-transfer-request']
    },
    {
        path: '/transfer-requests/:id/select-serials',
        perms: ['approve-transfer-request, reject-transfer-request', 'select-transfer-request-serials']
    },
    {
        path: '/transfer-requests/manage',
        perms: ['search-transfer-requests', 'approve-transfer-request', 'reject-transfer-request']
    },
    {
        path: '/transfer-requests/manage/:id',
        perms: ['get-truck-transfer-request', ['search-truck-transfer-requests', 'search-transfer-requests'], 'create-transfer-request', 'approve-transfer-request', 'reject-transfer-request', 'select-transfer-request-serials']
    }
]

export class RouteSecurity {
    public constructor(public readonly permissions: string[]) {
    }

    public isAuthorized(path: string) {
        let route = this.find(path)

        if (route) {
            for (let perm of route.perms) {
                if (typeof perm === 'string') {
                    if (!this.permissions.includes(perm))
                        return false
                } else if (!perm.some(x => this.permissions.includes(x))) {
                    return false
                }
            }
        }

        return true // if no route security is configured, allow it
    }

    public static fromMask(permMask: string | bigint): RouteSecurity {
        let perms: string[] = []
        let mask = BigInt(permMask)

        for (let pb of PERM_BITS)
            if (mask & pb.bit)
                perms.push(pb.perm)

        return new RouteSecurity(perms)
    }

    public find(path: string): RoutePerms | undefined {
        for (let rp of ROUTE_PERMS)
            if (path === rp.path || path.startsWith(`${rp.path}/`))
                return rp
    }
}
